// extracted by mini-css-extract-plugin
export default {"filter":"Filter_filter__n-xI1","mobile-filter":"Filter_mobile-filter__ppxR+"};